export default {"src":"/_next/static/media/phone-icon-magenta.40ebf05e.svg","height":474,"width":474};